import { makeStyles } from '@material-ui/core/styles';

const textDefault = {
  textTransform: 'uppercase',
  fontSize: '1rem',
};

const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: 3,
  },
  label: {
    ...textDefault,
  },
  menu: {
    backgroundColor: theme.palette.container.background,
    color: theme.palette.text.primary,
    ...textDefault,
    marginTop: '0.5rem',
    boxShadow: '3px 3px 6px rgba(0,0,0,0.1)',
    borderTop: '1px solid #eeeeee',
  },
  menuItem: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
}));

export default useStyles;
